import { useState } from 'react';

/**
 * Small "?" badge that shows a tooltip on hover (desktop) and on click (mobile).
 * Usage: <FieldHint text="Some explanation" />
 */
export default function FieldHint({ text }) {
  const [visible, setVisible] = useState(false);

  return (
    <span className="relative inline-flex items-center ml-1.5">
      <button
        type="button"
        onMouseEnter={() => setVisible(true)}
        onMouseLeave={() => setVisible(false)}
        onFocus={() => setVisible(true)}
        onBlur={() => setVisible(false)}
        onClick={() => setVisible((v) => !v)}
        aria-label="Field hint"
        className="w-4 h-4 rounded-full bg-slate-700 border border-slate-600 text-slate-400 hover:text-slate-200 hover:border-slate-400 text-[10px] font-bold flex items-center justify-center transition-colors focus:outline-none focus:ring-1 focus:ring-brand-500"
      >
        ?
      </button>
      {visible && (
        <div
          role="tooltip"
          className="absolute bottom-full left-1/2 -translate-x-1/2 mb-2 w-56 z-50 pointer-events-none"
        >
          <div className="bg-slate-800 border border-slate-600 rounded-xl shadow-xl px-3 py-2 text-xs text-slate-300 leading-relaxed">
            {text}
          </div>
          {/* Arrow */}
          <div className="absolute top-full left-1/2 -translate-x-1/2 border-4 border-transparent border-t-slate-600" />
        </div>
      )}
    </span>
  );
}
